import React from "react"
import "./write-for-us.scss"

const WriteForUs = () => {
  const text1 =
    process.env.LOCALE === "es-AR"
      ? "Elegí un tema que te apasione y escribí sobre esto. Podés inspirarte en tu hobbie favorito o algo de lo que sepas muchísimo."
      : "Elige un tema que te apasione y escribe sobre este. Puedes inspirarte en tu hobbie favorito o algo de lo que sepas muchísimo."

  const text2 =
    process.env.LOCALE === "es-AR"
      ? "Explicá de manera simple pero creativa el tema sobre el que querés hablar, es posible que ajustemos detalles para potenciar tu contenido."
      : "Explica de manera simple pero creativa el tema sobre el que quieres hablar, es posible que ajustemos detalles para potenciar tu contenido."

  return (
    <section className="f-create-for-us">
      <label className="f-title-section">
        Descubre cómo puedes escribir para Nosotras
      </label>

      <div className="f-cards-container">
        <div className="f-card-container">
          <span className="f-index">1</span>
          <span className="f-icon f-pencil-card" />
          <p className="f-card-description">{text1}</p>
        </div>
        <div className="f-card-container">
          <span className="f-index">2</span>
          <span className="f-icon f-heart-card" />
          <p className="f-card-description">{text2}</p>
        </div>
        <div className="f-card-container">
          <span className="f-index">3</span>
          <span className="f-icon f-user-card" />
          <p className="f-card-description">
            Nuestras expertas en contenido lo revisarán y si es uno de los
            contenidos elegidos podrás verlo en nuestro Magazín
          </p>
        </div>
      </div>
    </section>
  )
}

export default WriteForUs
